import Link from "next/link";

import { ProviderHooks } from "@/src/hook";
import { StrapiComponentType } from "@/src/type";

import { TextBreakpointModule } from "@/src/component/partial/__module__";

import styles from "./HeroStats.module.scss";

interface HeroStatsItem {
  stat: StrapiComponentType.Partial.Stat;
}

function HeroStatsItem({ stat }: HeroStatsItem) {
  const cms = ProviderHooks.useCMS();

  function constructLink() {
    return stat.isExternal ? stat.optionalHref : cms.constructLink(stat.optionalHref ?? "");
  }

  if (typeof stat.optionalHref === "string") {
    return (
      <Link
        className={styles.statContainer}
        href={constructLink() ?? ""}
        target={stat.target}
      >
        <TextBreakpointModule
          id={`heroStats_stat_${stat.id}`}
          text={stat.stat}
          className={styles.statTitle}
        />
        <TextBreakpointModule
          id={`heroStats_stat_${stat.id}`}
          text={stat.description}
          className={styles.statDescription}
        />
      </Link>
    );
  }

  return (
    <div className={styles.statContainer}>
      <TextBreakpointModule
        id={`heroStats_stat_${stat.id}`}
        text={stat.stat}
        className={styles.statTitle}
      />
      <TextBreakpointModule
        id={`heroStats_stat_${stat.id}`}
        text={stat.description}
        className={styles.statDescription}
      />
    </div>
  );
}

export default HeroStatsItem;
